import { VehicleFuelType } from "@1games-ru/region-shared/dist/enums/vehicle/vehicle";
import { isNull } from "lodash";
import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { cn } from "@/core/helpers/cn";

type Props = {
  timer: number | null;
  fuelType: VehicleFuelType | null;
  isElectric?: boolean;
  className?: string;
};

export default function GasStationRefueling({
  timer,
  fuelType,
  isElectric = false,
  className,
}: Props) {
  const { t } = useTranslation("gasStation");

  if (isNull(timer)) return null;

  return (
    <motion.div
      initial={{ opacity: 0, translateY: "100%" }}
      animate={{ opacity: 1, translateY: "none" }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      exit={{ opacity: 0, translateY: "100%" }}
      className={cn(
        "absolute h-full w-full backdrop-blur-[2px] rounded-[1rem] z-1",
        "flex flex-col items-center justify-center gap-5",
        className,
      )}
      style={{
        background:
          "linear-gradient(180deg, rgba(18, 18, 18, 0.00) 0%, rgba(var(--brand-color-rgb), 0.20) 100%), rgba(18, 18, 18, 0.96)",
      }}
    >
      <div className="text-accent text-[2rem] spinner" />
      {timer === 0 ? (
        <div className="text-18 font-bold text-white">
          {t(`gasStation.${isElectric ? "chargeEnd" : "refuelEnd"}`)}
        </div>
      ) : (
        <>
          <div className="flex flex-col gap-2 items-center">
            <div className="text-18 font-bold text-white">
              {t(`gasStation.${isElectric ? "chargeAuto" : "refuelAuto"}`)}
            </div>
            {fuelType && (
              <div className="text-15 font-medium text-accent">
                {isElectric ? "Electro" : t(`gasStation.fuelType.${fuelType.toLowerCase()}`)}
              </div>
            )}
          </div>
          <div className="text-[2rem] text-accent font-bold">{timer}</div>
        </>
      )}
    </motion.div>
  );
}
